import React, { useState, useContext } from 'react';
import ProjectsListCard from '/src/Components/ProjectsListCard/ProjectsListCard';
import { CurlyBraceDivider } from '/src/Components/CurlyBraceDivider/CurlyBraceDivider';
import { ArrowLeftRight, PiggyBank, TrendingUpDown, Receipt, Plus } from 'lucide-react';
import CTAButton from '/src/Components/CTAButton/CTAButton';
import './style.css';
import { WindowSizeContext } from '/src/App';

import './style.css';

const Summary = ({
    simulatorData,
    projectsList,
    handleSelectedProjectsListUpdate,
    propertyData,
    notSelectedProjectsList,
    handleUserAddingAProject,
    handleUserRemovingAProject,
    viewType,
    handleSectionMenuItemClick
}) => {

    const { deviceType } = useContext(WindowSizeContext);

    const [showChangeProjects, setShowChangeProjects] = useState(false);

    const allRecommendedProjectsList = propertyData?.data?.recommended_projects?.projects_list || [];
    const allRecommendedProjectsListLength = allRecommendedProjectsList.length;

    const toggleOptions = [
        {
            id: 'diy',
            label: 'Do It Myself'
        },
        {
            id: 'pro',
            label: 'Hire a Pro'
        }
    ]

    const dummyHandleProjectClick = (project) => {
        return;
    }

    const handleToggleOptionClick = (option, projectId) => {
        // Create new array with immutable updates
        const updatedProjectsList = projectsList.map(project => {
            if (project.project_id === projectId) {
                return {
                    ...project,
                    diyPreference: option
                };
            }
            return project;
        });

        // Safe callback execution
        if (typeof handleSelectedProjectsListUpdate === 'function') {
            console.log('handleSelectedProjectsListUpdate is available and is a function', updatedProjectsList);
            handleSelectedProjectsListUpdate(updatedProjectsList);
        } else {
            console.warn('handleSelectedProjectsListUpdate is not available or not a function');
            // Optionally, you could implement a default behavior here
            // For example, you could store the state locally as a fallback
        }
    }


    let leftColumnHeaderText = `For each project, select who would be doing the work...`;
    if (viewType === 'changeProjects') {
        leftColumnHeaderText = `Current Projects (${projectsList.length})`;
    }
    const letsSaySentence = `Who would be doing the work on the project${projectsList.length > 1 ? 's' : ''}...`
    const introSentence = 'The What If Machine is a tool designed to help you understand the potential benefits from different combinations of home resilience projects. It is a tool that allows you to explore the potential benefits of different combinations of home resilience projects.'

    const theseVsAllProjectsText = `These ${projectsList.length} projects, in the context of all ${allRecommendedProjectsListLength > 0 ? allRecommendedProjectsListLength : 'recommended'} projects, represent:`

    const preProjectBreakdownText = 'Here is how much of those totals each project is contributing to the costs and payoff of this plan:'

    const confirmWhoDoesWorkText = 'See the Results'

    return (
        <div className={`what-if-machine-plan-summary-content-section-container ${viewType}`}>
            <div className={`what-if-machine-plan-projects-container ${viewType === 'summary' ? 'single-column' : 'two-column'} ${deviceType}`}>

                <div className="what-if-machine-plan-projects-container-column left">
                    <h3>{leftColumnHeaderText}</h3>
                    <div className="what-if-machine-plan-summary-subsections-container">
                        <div className="what-if-machine-plan-summary-projects-container">
                            {projectsList.map((project) => {

                                const diyPreference = project.diyPreference;
                                return (
                                    <div className="what-if-machine-plan-summary-individual-project">
                                        <ProjectsListCard
                                            project={project}
                                            handleProjectClick={dummyHandleProjectClick}
                                            showAllDetails={false}
                                            simulatorView={viewType === 'changeProjects' ? true : false}
                                            isSelected={true}
                                            handleAddingProjectToSimulator={handleUserAddingAProject}
                                            handleRemovingProjectFromSimulator={handleUserRemovingAProject}
                                        />
                                        <div className="what-if-machine-plan-summary-individual-project-who-does-work-toggle-container">
                                            {toggleOptions.map((option, index) => {

                                                const isSelected = diyPreference === option.id;
                                                return (
                                                    <div
                                                        className={`what-if-machine-plan-summary-individual-project-who-does-work-toggle-option ${isSelected ? 'selected' : ''}`}
                                                        // onClick only if the option is not selected
                                                        onClick={() => !isSelected && handleToggleOptionClick(option.id, project.project_id)}
                                                        key={`combo-lab-toggle-option-${index}`}
                                                    >
                                                        <span className={`what-if-machine-plan-summary-individual-project-who-does-work-toggle-option-label ${isSelected ? 'selected' : ''}`}>{option.label}</span>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                        {viewType === 'summary' && (
                            <CTAButton
                                onClick={() => handleSectionMenuItemClick('analysis')}
                                text={confirmWhoDoesWorkText}
                            />
                        )}
                    </div>
                </div>
                {viewType === 'changeProjects' && (
                    <div className="what-if-machine-plan-projects-container-column right">
                        <h3>Add More Projects ({notSelectedProjectsList.length})</h3>
                        <div className="what-if-machine-plan-summary-change-projects-container">
                            {notSelectedProjectsList.map((project) => {
                                return (
                                    <ProjectsListCard
                                        project={project}
                                        handleProjectClick={dummyHandleProjectClick}
                                        showAllDetails={false}
                                        simulatorView={true}
                                        isSelected={false}
                                        handleAddingProjectToSimulator={handleUserAddingAProject}
                                        handleRemovingProjectFromSimulator={handleUserRemovingAProject}
                                    />
                                )
                            })}
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

export default Summary;







{/* <div className="what-if-machine-plan-summary-divider-container">
    <CurlyBraceDivider />
</div>
<div className="what-if-machine-plan-summary-financial-content-container">
    <div className="what-if-machine-plan-summary-financial-content-container-row">
        <div className="what-if-machine-plan-summary-financial-content-container-row-item costs">
            <div className="what-if-machine-plan-summary-financial-content-container-row-item-costs-header">
                <div className="what-if-machine-plan-summary-financial-content-container-row-item-costs-header-total-cost-icon-container">
                    <Receipt />
                </div>
                <div className="what-if-machine-plan-summary-financial-content-container-row-item-costs-header-total-cost">
                    <span>Est. Cost: {simulatorData.totals.totalCost.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0 })}</span>
                </div>
            </div>
            <div className="professional-type-cost-container-breakdown">
                <span className="professional-type-cost-text">Labor: {simulatorData.totals.costLabor.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0 })}</span>
                <div className="professional-type-cost-container-breakdown-icon-container small">
                    <Plus />
                </div>
                <span className="professional-type-cost-text">Materials: {simulatorData.totals.costMaterials.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0 })}</span>
            </div>
        </div>
        <div className="what-if-machine-plan-summary-financial-content-container-row-item">
            <ArrowLeftRight />
        </div>
        <div className="what-if-machine-plan-summary-financial-content-container-row-item payoff">
            <div className="what-if-machine-plan-summary-financial-content-container-row-item-payback">
                <span>Est. Payoff </span>
                <div className="professional-type-cost-container-breakdown-text-container">
                    <div className="professional-type-cost-container-breakdown-icon-container">
                        <PiggyBank />
                    </div>
                    <span>{simulatorData.totals.totalPayoff.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0 })}</span>
                </div>
            </div>
            <div className="what-if-machine-plan-summary-financial-content-container-row-vertical-divider" />
            <div className="what-if-machine-plan-summary-financial-content-container-row-item-payback">
                <span>Est. Years to Payback </span>
                <div className="professional-type-cost-container-breakdown-text-container">
                    <div className="professional-type-cost-container-breakdown-icon-container">
                        <TrendingUpDown />
                    </div>
                    <span>{simulatorData.payback.breakEvenYear}</span>
                </div>
            </div>
        </div>
    </div>
</div> */}